import { lazy } from 'react';
function lazyWithPreload(factory) {
  const Component = /*#__PURE__*/lazy(factory);
  Component.preload = factory;
  return Component;
}
export const unifiedAuthBreezeRegistryEntry = {
  namespace: 'UNIFIED_AUTH',
  components: {
    CONNECT_APP: lazyWithPreload(() => import( /* webpackChunkName: "unified-auth-breeze" */'./BreezeDataSyncAuth'))
  }
};